import { TariffCompatibility } from './TariffCompatibility.ts';

export const MIN_SPECIAL_DAY_COUNT = 0;
export const MAX_SPECIAL_DAY_COUNT = 100;
export const MIN_SPECIAL_DAY_OF_YEAR_COUNT = 0;
export const MAX_SPECIAL_DAY_OF_YEAR_COUNT = 15;

export interface SlopeDefinition {
    minutes: number;
    rappen: number;
}

export interface TariffCurveDefinition {
    curveDefinitionId: number;
    name: string;
    curve: SlopeDefinition[];
}

export interface DayScheduleEntry {
    curveDefinitionId: number;
    start: string;
    end: string;
    totalTimeLimitMinutes: number | null;
    resetDurationAtStart: boolean;
}

export interface DayProfile {
    dayProfileId: number;
    name: string;
    schedule: DayScheduleEntry[];
}

export interface SpecialDayProfile {
    date: string;
    dayIdRef: number;
}

export interface SpecialDayOfYearProfile {
    dayOfYear: string;
    dayIdRef: number;
}

export interface WeekProfile {
    weekProfileId: number;
    name: string;
    mondayProfileId: number;
    tuesdayProfileId: number;
    wednesdayProfileId: number;
    thursdayProfileId: number;
    fridayProfileId: number;
    saturdayProfileId: number;
    sundayProfileId: number;
}

export interface SeasonProfile {
    name: string;
    start: string;
    end: string;
    weekProfileId: number;
}

export type InheritMode = 'reset' | 'inheritTime';

export enum MaxAmountType {
    _24h = '_24h',
    calendarDay = 'calendarDay',
}

export interface MaxAmountPerDayConfig {
    type: MaxAmountType;
    rappen: number;
}

export interface FrontendTariffDefinition {
    tariffCompatibility: TariffCompatibility;
    inheritMode: InheritMode;
    resetToTimeOnSlopeAtMidnightInMinutes: number | null;
    maxAmountPerDayConfig: MaxAmountPerDayConfig | null;
    seasons: SeasonProfile[];
    weeks: WeekProfile[];
    days: DayProfile[];
    specialDays: SpecialDayProfile[];
    specialDaysOfYear: SpecialDayOfYearProfile[];
    curves: TariffCurveDefinition[];
    holidays: HolidayProfile[];
    calculationMode: TariffCalculationMode | null;
}

export enum CalculationModeType {
    ROUND_TO_STEP = 'ROUND_TO_STEP',
    EXACT = 'EXACT',
}

export type TariffCalculationMode =
    | RoundToStepCalculation
    | ExactRappenCalculation;
interface TariffCalculationModeBase {
    type: CalculationModeType;
}

interface RoundToStepCalculation extends TariffCalculationModeBase {
    type: CalculationModeType.ROUND_TO_STEP;
}

interface ExactRappenCalculation extends TariffCalculationModeBase {
    type: CalculationModeType.EXACT;
    minChfStepRappen: number;
}

export interface HolidayProfile {
    dayIdRef: number;
    holidayKey: HolidayKey;
}

export type HolidayKey =
    // fixed days in each year
    | 'NewYear'
    | 'Berchtoldstag'
    | 'Epiphany'
    | 'MariaLichtmess'
    | 'StJosef'
    | 'LaborDay'
    | 'StPeterAndPaul'
    | 'NationalDayCH'
    | 'AssumptionOfMary'
    | 'NationalDayLI'
    | 'MaryBirth'
    | 'AllSaintsDay' // Allerheiligen
    | 'AndreasTag'
    | 'ConceptionOfMary' // Mariä Empfängnis
    | 'ChristmasEve'
    | 'Christmas'
    | 'StStephensDay'
    | 'NewYearsEve'
    // variable in every year
    | 'HilariFriday'
    | 'HilariSaturday'
    | 'GoodFriday'
    | 'Easter'
    | 'EasterMonday'
    | 'AscensionDay'
    | 'Pentecost'
    | 'PentecostMonday'
    | 'CorpusChristi'
    | 'Maienzug'
    | 'KnabenschiessenMonday'
    | 'BettagSunday'
    | 'BettagMonday'
    | 'BettagGeneva';

export interface Slope {
    miliSecs: number;
    rappen: number;
}
